function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchFieldContext } from './SearchField';
import { pointWktToCoordinates } from '../utils/pointWktToCoordinates';
var VectorLayer = null;

var provideMapState = function provideMapState() {
  return null;
};

var olUtils = {};

try {
  // Only provide component if react-openlayers is present in parent project
  var _require = require('@avinet/react-openlayers'),
      _VectorLayer = _require.VectorLayer,
      _provideMapState = _require.provideMapState,
      _olUtils = _require.olUtils;

  VectorLayer = _VectorLayer;
  provideMapState = _provideMapState;
  olUtils = _olUtils;
} catch (ex) {}
/**
 * When a surrounding `Map` and `SearchField` are available, this renders the results to a `VectorLayer`.
 *
 * Usage:
 *
 * ```js
 * <Map>
 *   <SearchField>
 *     <SearchAgent />
 *     <SearchLayer name='search-layer' />
 *   </SearchField>
 * </Map>
 * ```
 *
 * See `VectorLayer` for available props to override styling.
 */


var SearchLayer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SearchLayer, _Component);

  function SearchLayer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SearchLayer.prototype;

  _proto.render = function render() {
    var _this$context = this.context,
        searchResults = _this$context.searchResults,
        showResults = _this$context.showResults;
    var features = [];
    var _this$props = this.props,
        projCode = _this$props.projCode,
        showLabels = _this$props.showLabels;

    if (searchResults && showResults) {
      searchResults.forEach(function (result) {
        if (!result.olFeature && result.geom) {
          var coords = pointWktToCoordinates(result.geom, result.srid, projCode);

          if (coords) {
            result.olFeature = olUtils.createFeatureFromGeometry(olUtils.createPoint(coords), {
              title: result.title
            });
          }
        }

        if (result.olFeature) {
          features.push(result.olFeature);
        }
      });
    }

    var featureStyle = this.props.featureStyle;

    if (!featureStyle) {
      featureStyle = {
        pointRadius: 5,
        fillColor: '#ff0000',
        strokeColor: '#660000',
        strokeWidth: 0.7,
        fontColor: '#333333'
      };
    }

    if (showLabels) {
      featureStyle = _extends({}, featureStyle, {
        labelMinZoom: 10,
        labelPadding: [2, 4, 2, 4],
        labelOffsetX: 6,
        labelOffsetY: -10,
        labelBackgroundFill: 'rgba(255,255,255,.75)',
        labelTextAlign: 'left',
        labelProperty: 'title'
      });
    }

    return /*#__PURE__*/React.createElement(VectorLayer, _extends({
      features: features,
      featureStyle: featureStyle,
      useHoverStyle: true
    }, this.props));
  };

  return SearchLayer;
}(Component);

_defineProperty(SearchLayer, "contextType", SearchFieldContext);

SearchLayer.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired
} : {};
export default provideMapState(SearchLayer);